import React, { useState, useEffect, useRef } from "react";
import { _getBaseUrl, _makeId, _isFirstRender } from "../utils/helper";
import { Checkbox } from "../forms";

const TopicDropDown = ({ placeholder, ...props }) => {
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [collapseTopics, setCollapseTopics] = useState();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (props.options !== undefined) {
      setCollapseTopics(props.options.map((item, idx) => { return false; }));
    }
  }, [props.options]);


  useEffect(() => {
    if (isExpanded) {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  }, [isExpanded]);

  const dropdownExpandHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const onChangeHandler = (checked, value) => {
    props.onChange(props.filter, value, checked);
  };

  const onSearch = (e) => {
    const searchText = e.target.value.toLowerCase();

    if (searchText.trim() === '') {
      return;
    }

    let temp = collapseTopics.map((item) => {
      return true;
    })

    // If text search is active, expand all topics
    setCollapseTopics(temp);
    setSearchText(searchText);
  }

  const searchMatch = (label, tier = 'sub', subTopics = null) => {
    const match = label.toLowerCase().indexOf(searchText.toLowerCase());

    if (tier === 'parent') {
      let subTopicMatched = false;

      if (subTopics !== null) {
        subTopics.map((item) => {
          const subTopicMatch = item.label.toLowerCase().indexOf(searchText.toLowerCase());
  
          if (subTopicMatch > -1) {
            subTopicMatched = true;
          }
        });
      }

      if (subTopicMatched) {
        return 'block';
      }
    }

    return match > -1 ? "block" : "hidden";
  }

  const resetSearch = (label) => {
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }

    let temp = collapseTopics.map((item) => {
      return false;
    })

    // When text search is reset, collapse all topics
    setCollapseTopics(temp);
    setSearchText('');
  }

  const isAllSubTopicsChecked = (subTopics) => {
    let checked = false;

    if (subTopics !== undefined) {
      checked = true;

      subTopics.map((item) => {
        const found = props.topicsValues.filter((v) => {
          return v === item.value;
        });
  
        if (found.length <= 0) {
          checked = false;
        }
      });
    }

    // console.log('isAllSubTopicsChecked props.topicsValues', props.topicsValues);

    return checked;
  }

  return (
    <div className="filter-dropdown--wrapper relative" ref={dropdownRef}>
      <div
        className={`border border-black h-[70px] px-4 lg:px-5 flex items-center justify-between cursor-pointer ${props.toggleClass ? props.toggleClass : ''}`}
        onClick={() => dropdownExpandHandler()}
      >
        <span className="text-sm lg:text-base">{placeholder}</span>
        <img src={`${_getBaseUrl('src/assets/icon-download.svg', true)}`} alt="" className={`filter brightness-0 ${isExpanded ? 'rotate-180' : ''}`} />
      </div>
      {isExpanded && (
        <div className={`filter-dropdown--tray bg-white border border-black xl:border-t-0 md:absolute md:z-10 md:top-full md:left-0 p-5 ${props.trayClass ? props.trayClass : 'w-full'}`}>
          <div className="mb-3 relative">
            <input type="text" className="border border-black w-full h-[60px] lg:h-[70px] px-4 pr-12" 
              placeholder="Keyword search"
              onKeyUp={onSearch}
              ref={searchInputRef}
              />
            
            <img src={`${_getBaseUrl('src/assets/icon-search.svg', true)}`} alt="" 
              className={`object-contain w-[20px] h-[20px] absolute top-1/2 right-4 -translate-y-1/2 ${ searchText.length > 0 && 'hidden' }`} 
              />
            <img src={`${_getBaseUrl('src/assets/icon-remove.svg', true)}`} alt="" 
              className={`object-contain w-[16px] h-[16px] absolute top-1/2 right-4 -translate-y-1/2 hover:opacity-60 transition-opacity cursor-pointer ${ searchText.length <= 0 && 'hidden' }`} 
              onClick={resetSearch}
              />
          </div>
          <div className="max-h-[400px] overflow-y-auto pr-4 grid grid-cols-1 gap-2">
            {props.options !== undefined &&
              props.options.length > 0 &&
              props.options.map((item, idx) => {
                return (
                  <div className="grid gap-2">
                    
                    {/* <div className={searchMatch(item.label)}>{item.label}</div> */}

                    <div className={`flex items-center justify-between ${searchMatch(item.label, 'parent', item.subTopics)}`}>
                      <Checkbox
                        label={item.label}
                        value={item.value}
                        // checked={props.value.indexOf(item.value) >= 0 ? true : false}
                        checked={props.value.indexOf(item.value) >= 0 ? true : false}
                        onChange={onChangeHandler}
                      />
                      {props.collapsible &&
                        <img 
                          src={`${_getBaseUrl('src/assets/icon-dropdown.svg', true)}`} 
                          alt="" 
                          className={`cursor-pointer hover:opacity-70 ${collapseTopics[idx] ? 'rotate-180' : ''}`} 
                          onClick={() => {
                            let temp = [...collapseTopics];
                            temp[idx] = !temp[idx];
                            setCollapseTopics(temp);
                          }} />
                      }
                    </div>


                    {item.subTopics !== undefined && item.subTopics.length > 0 && ((props.collapsible && collapseTopics[idx]) || !props.collapsible) &&
                      item.subTopics.map((subItem) => {
                        return (
                          <div className={searchMatch(subItem.label)}>
                            <div className="ml-4">
                              <Checkbox
                                label={subItem.label}
                                value={subItem.value}
                                checked={props.value.indexOf(subItem.value) >= 0 ? true : false}
                                onChange={onChangeHandler}
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TopicDropDown;
